import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import playlistService from "../../services/PlaylistService.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";
import TitleCard from "../Nano/TitleCard.js";
import Grid from "../Macro/Grid.js";
import WrapperList from "../Nano/WrapperList.js";

//IMAGES
import { ReactComponent as SearchIcon } from "../Global/Icons/search.svg";
import { ReactComponent as RemovePlaylist } from "../Global/Icons/removePlaylist.svg";
import { ReactComponent as Check } from "../Global/Icons/check.svg";

import NotaIcon from "../Global/Icons/nota-icon.svg";

const multiple = nota.global.multiple;

const RemoveFromPlaylistModalStyle = styled.div`
  width: 500px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.mTwo};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.mTwo};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }
  .loadingContainer {
    min-height: 406px;
  }
  .modalInfoText {
    text-align: center;
    margin-bottom: 16px;
  }

  /* INPUT SEARCH */
  .inputWrapper {
    width: 100%;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
  }

  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }

  /* LIST */
  .list {
    margin-top: ${multiple + "px"};
    max-height: 250px;
    overflow: auto;
    padding: ${multiple + "px"};
    background: ${nota.color.neutral.lightGrey};
    min-height: 264px;
    background-image: url(${NotaIcon});
    background-repeat: no-repeat, repeat;
    background-size: 50% 50%;
    background-position: center;
  }
  .listContainer {
    height: auto;

    .itemContainer {
      width: 100%;
      height: auto;
      margin-bottom: ${multiple / 2 + "px"};
      .selectItem {
        width: ${multiple * 5 + "px"};
        height: auto;
        background-color: ${nota.color.neutral.NeuFour};
        cursor: pointer;
        border-right: 1px solid ${nota.color.neutral.NeuFive};
        .iconContainer {
          svg {
            width: 16px;
            height: 20px;
            path {
              fill: ${nota.color.neutral.NeuTwo};
            }
          }
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .wrapperList {
        padding: 0;
        margin: 0;
        border: 1px solid ${nota.color.neutral.NeuFour};
        box-shadow: none;

        .headerContainer {
          height: auto;
        }
        .titleCard {
          margin-top: ${multiple + "px"};
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple / 2 + "px"};
          width: 85%;
          height: auto;
          h3 {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .descriptionWrapper {
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple + "px"};
          width: 85%;
          height: auto;
          p {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .noInfo {
          margin-bottom: ${multiple + "px"};
          font-size: 12px;
          color: ${nota.color.neutral.NeuThree};
          line-height: unset;
          height: auto;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .selectedItem {
      .selectItem {
        background-color: ${nota.color.main.default};
        border-right: 1px solid ${nota.color.main.default};
        .iconContainer {
          svg {
            path {
              fill: ${nota.color.neutral.white};
            }
          }
        }
      }
      .wrapperList {
        border: 1px solid ${nota.color.main.default};
      }
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    .modalContainer {
      max-width: 100%;
      .btnsContainer {
        flex-direction: column;
        height: auto;
        .buttonWrapper {
          order: 1;
        }
        .simpleButtonWrapper {
          order: 2;
          margin-top: 8px;
        }
      }
    }
  }

  @media only screen and (max-width: 320px) {
    .headerModal {
      h3 {
        font-size: 16px;
      }
    }
  }

  @media only screen and (max-height: 630px) {
    .list {
      max-height: 24vh;
      min-height: 24vh;
    }
  }
`;

export class RemoveFromPlaylistItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  canShow = () => {
    if (this.props.term.trim() !== "") {
      let upperTerm = this.props.term.trim().toUpperCase();
      let upperName = this.props.playlist.name.trim().toUpperCase();
      return upperName.startsWith(upperTerm);
    }
    return true;
  };

  selectedChange = () => {
    this.props.onSelectedChange(this.props.playlist.id);
  };

  render() {
    if (this.canShow() == false) return null;

    return (
      <NanoFlex className={`itemContainer ${this.props.selected ? "selectedItem" : ""}`}>
        <NanoFlex className="wrapperListContainer" flexDirection={"row"} alignItems={"stretch"}>
          <NanoFlex className="selectItem" alignItems={"stretch"} onClick={this.selectedChange}>
            <NanoFlex className="iconContainer">
              <Check />
            </NanoFlex>
          </NanoFlex>

          <NanoFlex flexDirection={"column"} justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
            <WrapperList className="wrapperList">
              <NanoFlex className="headerContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex className="titleCard" justifyContent={"flex-start"}>
                  <Type.h3 title={this.props.playlist.name}>
                    <b>{this.props.playlist.name}</b>
                  </Type.h3>
                </NanoFlex>
                <NanoFlex className="descriptionWrapper" justifyContent={"flex-start"}>
                  {this.props.playlist.description && <Type.p title={this.props.playlist.description}>{this.props.playlist.description}</Type.p>}
                </NanoFlex>
              </NanoFlex>
            </WrapperList>
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}

class RemoveFromPlaylistModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      term: "",
      loading: true,
      playlists: [],
      selectedPlaylists: this.props.selectedPlaylists ? this.props.selectedPlaylists : [],
      requestId: 0,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    this.getComponentData();

    window.addEventListener("playlistsChange", this.onPlaylistsListChange, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedPlaylists !== this.props.selectedPlaylists) {
      this.setState({ selectedPlaylists: this.props.selectedPlaylists ? this.props.selectedPlaylists : [] });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("playlistsChange", this.onPlaylistsListChange, false);
  }

  onPlaylistsListChange = () => {
    this.getPlaylists();
  };

  getComponentData = () => {
    this.getPlaylists();
  };

  getPlaylists = () => {
    playlistService
      .getPlaylists()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        if (this.props.playlistLoadAction) {
          this.props.playlistLoadAction(data);
        }
        this.setState({
          playlists: data,
          loading: false,
          requestId: this.state.requestId + 1,
        });
      });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  onPlaylistSelectionChange = (e) => {
    this.setState({
      selectedPlaylists: e.selected.map((v) => {
        return v.id;
      }),
    });
  };

  addToPlaylist = () => {
    this.setState({ loading: true }, () => {
      playlistService
        .removeProgramsToPlaylist({
          IdPlaylists: this.state.selectedPlaylists,
          Filter: this.props.filter,
        })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          window.dispatchEvent(new Event("playlistsChange"));

          this.setState(
            {
              loading: false,
              selectedPlaylists: [],
            },
            () => {
              this.props.nextAction(this.state.selectedPlaylists);
            }
          );
        });
    });
  };

  cancelAddToPlaylist = () => {
    this.props.cancelAction();
  };

  onSelectedChange = (id) => {
    let selectedId = this.state.selectedPlaylists.find((v) => v === id);
    if (selectedId) {
      this.setState({ selectedPlaylists: this.state.selectedPlaylists.filter((v) => v !== id) });
    } else {
      this.setState({ selectedPlaylists: [...this.state.selectedPlaylists, id] });
    }
  };

  render() {
    return (
      <RemoveFromPlaylistModalStyle>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <RemovePlaylist />
          <Type.h3>
            <b>{this.translation.playlists.removeFromPlaylists}</b>
          </Type.h3>
        </NanoFlex>
        {this.state.loading && (
          <NanoFlex className="loadingContainer">
            <Spinner />
          </NanoFlex>
        )}
        {!this.state.loading && (
          <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
            <NanoFlex className="modalWrapper" flexDirection={"column"}>
              <NanoFlex className="modalInfoText" flexDirection={"column"}>
                <Type.p>{this.translation.components.removeFromPlaylistModal.removeFirst}</Type.p>
                <Type.p>
                  <b>
                    {this.props.count} {this.props.count > 1 ? this.translation.geral.programmes : this.translation.geral.programme}
                  </b>{" "}
                  {this.translation.components.removeFromPlaylistModal.removeLast}
                </Type.p>
              </NanoFlex>
              <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                <Input title={null} defaultValue={this.state.term} placeholder={this.translation.playlists.searchPlaylistPlaceholder} onChangeAction={this.onTermChange} />
                <NanoFlex className="searchIconWrapper">
                  <SearchIcon />
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="list" justifyContent={"flex-start"} alignItems={"flex-start"}>
                {/*LIST*/}
                <NanoFlex className="listContainer" flexDirection={"column"}>
                  {/* ITEM  */}
                  {this.state.playlists &&
                    this.state.playlists.map((item) => {
                      return <RemoveFromPlaylistItem playlist={item} key={item.id} requestId={this.state.requestId} term={this.state.term} selected={this.state.selectedPlaylists.includes(item.id)} onSelectedChange={this.onSelectedChange}></RemoveFromPlaylistItem>;
                    })}
                  {/* END ITEM  */}
                </NanoFlex>
                {/* END LIST  */}
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
              <Button label={this.translation.geral.cancel} simple clickAction={this.cancelAddToPlaylist} />
              <Button label={this.translation.geral.confirm} disable={this.state.selectedPlaylists.length == 0} clickAction={this.addToPlaylist} />
            </NanoFlex>
          </NanoFlex>
        )}
      </RemoveFromPlaylistModalStyle>
    );
  }
}

// Set default props
RemoveFromPlaylistModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default RemoveFromPlaylistModal;

/*
Doc
import RemoveFromPlaylistModal from '../../Micro/Warning.js';

<RemoveFromPlaylistModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
